//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 功能模块定义
const flowableDefine = () => import('../../pages/flowableManage/definition/flowableDefine');

const flowableManage = {
  path: '/flowable',
  component: index,
  children: [
    {
      path: 'definition',
      name: 'definition',
      component: flowableDefine,
      meta: {
        keepAlive: true,
        title: '流程定义',
      },
    },
    {
      path: 'model',
      name: 'model',
      component: () => import('../../pages/flowableManage/definition/model'),
      meta: {
        keepAlive: true,
        title: '流程设计',
      },
    },
    {
      path: 'process',
      name: 'process',
      component: () => import('../../pages/flowableManage/task/process'),
      meta: {
        keepAlive: true,
        title: '我的流程',
      },
    },
    {
      path: 'todo',
      name: 'todo',
      component: () => import('../../pages/flowableManage/task/todo'),
      meta: {
        keepAlive: true,
        title: '待办任务',
      },
    },
    {
      path: 'finished',
      name: 'finished',
      component: () => import('../../pages/flowableManage/task/finished'),
      meta: {
        keepAlive: true,
        title: '已办任务',
      },
    },
    {
      path: 'record',
      name: 'record',
      component: () => import('../../pages/flowableManage/task/record/index'),
      meta: {
        keepAlive: true,
        title: '流程处理',
      },
    },
  ],
};
export default flowableManage;
